import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../../assets/img/phone.png'


const _hoisted_1 = { class: "servicedetail" }
const _hoisted_2 = { class: "label-content" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "classify" }
const _hoisted_5 = { class: "price" }
const _hoisted_6 = { class: "info-content" }
const _hoisted_7 = ["innerHTML"]

import {onMounted,ref} from 'vue'
import {useRoute} from 'vue-router'
import weChatApi from "@/utils/Api/WeChat";

export default /*@__PURE__*/_defineComponent({
  __name: 'servicedetail',
  setup(__props) {

const route=useRoute();
onMounted(()=>{
  document.title='平台名称'
  getData();
})

const info=ref({})
const getData=()=>{
  weChatApi.getServiceItemDetail(route.query.id).then(res=>{
    console.log(res)
    info.value=res.data;
    info.value.itemImg=JSON.parse(res.data.itemImg)
  })
}


return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_swipe, {
      class: "swiper",
      autoplay: 3000,
      "indicator-color": "white"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.itemImg, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_swipe_item, { key: index }, {
            default: _withCtx(() => [
              _createVNode(_component_van_image, {
                class: "img",
                src: item.url
              }, null, 8, ["src"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(info.value.itemname), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(info.value.categoryName), 1),
      _createElementVNode("div", _hoisted_5, [
        _cache[0] || (_cache[0] = _createElementVNode("span", null, "¥", -1)),
        _createTextVNode(_toDisplayString(info.value.itemprice), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "品项详情", -1)),
      _createElementVNode("div", {
        class: "content",
        innerHTML: info.value.itemdesc
      }, null, 8, _hoisted_7)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "call-btn" }, [
      _createElementVNode("img", { src: _imports_0 }),
      _createElementVNode("div", null, "服务咨询")
    ], -1)),
    _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"height":"5.8rem"} }, null, -1))
  ]))
}
}

})